var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcono0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#36504B;}\r\n\t.st1{fill:#B0F7D5;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451,140H338V15c0-8.3-6.7-15-15-15H31c-8.3,0-15,6.7-15,15v482c0,8.3,6.7,15,15,15h420c24.8,0,45-20.2,45-45 V185C496,160.2,475.8,140,451,140z M308,74.1c-21.6-5.5-38.6-22.5-44.1-44.1H308V74.1z M233.2,30c6.4,38.2,36.6,68.4,74.8,74.7V140 h-33c-20,0-37,13.1-42.8,31.2c-17.6-3.5-36-5.2-55.2-5.2c-41.3,0-80.4,8.4-110.1,23.6c-7.8,4-14.8,8.4-20.9,13.1v-98 c38.2-6.4,68.4-36.6,74.8-74.8L233.2,30L233.2,30z M230,310.6c-16.7,3.6-34.5,5.4-53,5.4c-77.2,0-131-31.6-131-60s53.8-60,131-60 c18.2,0,36.3,1.9,53,5.4V310.6z M90.1,30C84.6,51.6,67.6,68.6,46,74.1V30L90.1,30z M46,437.9c21.6,5.5,38.6,22.5,44.1,44.1H46 V437.9z M46,407.2v-98c6.1,4.7,13.1,9.1,20.9,13.1C96.6,337.6,135.7,346,177,346c18.3,0,36.1-1.6,53-4.8V467c0,5.3,0.9,10.3,2.6,15 H120.8C114.4,443.8,84.2,413.6,46,407.2z M275,482c-8.3,0-15-6.7-15-15V185c0-8.3,6.7-15,15-15h71v312H275z M376,482V170h30v312 H376z M466,467c0,8.3-6.7,15-15,15h-15V170h15c8.3,0,15,6.7,15,15V467z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177,130c8.3,0,15-6.7,15-15V94c0-8.3-6.7-15-15-15s-15,6.7-15,15v21C162,123.2,168.7,130,177,130z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177,382c-8.3,0-15,6.7-15,15v21c0,8.3,6.7,15,15,15s15-6.7,15-15v-21C192,388.8,185.3,382,177,382z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M346,170v312h-71c12.3-34.4,24.3-77.5,31-128c9.8-74.3,4.6-137.9-3-184C317.3,170,331.7,170,346,170z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono0);
export default __webpack_public_path__ + "static/media/icono0.c2f78a9e4a12280bbb12ccec95039f5c.svg";
export { ForwardRef as ReactComponent };